/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from './types.tsx';

const updateExperiment =
	(experimentKey: string, value: boolean): Action<State> =>
	({ setState }) => {
		// @ts-expect-error - TS2345 - Argument of type '{ [x: string]: { data: { value: boolean; }; loading: false; error: null; }; }' is not assignable to parameter of type 'Partial<State>'.
		setState({
			[experimentKey]: {
				data: { value },
				loading: false,
				error: null,
			},
		});
	};

export default updateExperiment;
